import { EventEmitter } from 'events';

// Variables
let _isPaused = false;

let autoPauseDelayMilliseconds;
let autoPauseEnabled = false;

let autoPauseTimeoutKey = undefined;

// Private functions
const autoPause = () => {
  if (autoPauseEnabled) {
    pause();
  }
};
const resetAutoPauseTimeout = () => {
  clearTimeout(autoPauseTimeoutKey);
  autoPauseTimeoutKey = setTimeout(autoPause, autoPauseDelayMilliseconds);
};

// Public functions
/**
 * 'pause' and 'resume' events will be emitted on this EventEmitter when the app is paused/resumed.
 *
 * Example usage:
 *
 * ```
 * pauseEvents.on('pause', onPause);
 * ...
 * pauseEvents.removeListener('pause', onPause);
 * ```
 */
export const pauseEvents = new EventEmitter();

export function isPaused() {
  return _isPaused;
}

export function pause() {
  if (_isPaused) {
    return;
  }

  _isPaused = true;

  pauseEvents.emit('pause');
}

export function resume() {
  if (_isPaused) {
    pauseEvents.emit('resume');
  }

  resetAutoPauseTimeout();

  _isPaused = false;
}

/**
 * If the user doesn't trigger any input events for delayMilliseconds milliseconds,
 * automatically pause.
 *
 * @param {Number} delayMilliseconds
 */
export function enableAutoPause(delayMilliseconds) {
  if (autoPauseEnabled) {
    return;
  }

  autoPauseEnabled = true;
  autoPauseDelayMilliseconds = delayMilliseconds;

  // Reset the auto-pause timeout on input events.
  ['click', 'dragover', 'mousemove', 'keydown', 'keypress'].forEach((event) => {
    document.addEventListener(event, resetAutoPauseTimeout);
  });

  resetAutoPauseTimeout();
}

export function disableAutoPause() {
  if (!autoPauseEnabled) {
    return;
  }

  autoPauseEnabled = false;

  // Remove the reset timeout events.
  ['click', 'dragover', 'mousemove', 'keydown', 'keypress'].forEach((event) => {
    document.removeEventListener(event, resetAutoPauseTimeout);
  });

  resetAutoPauseTimeout();
}
